import React from "react";
import GroupAllUsers from "../FieldTags/GroupAllUsers";
import xplanLabels from "../../util/XplanLabels";
import HistoryLogElement from "./HistoryLogElement";
import { Autocomplete, Chip, TextField } from '@mui/material';

const newPlan = window.location.pathname === "/xplans/new";

const Related = ({ related, handleChange, xplans, epList }) => {
    return (
        <div id="related" className="planField">
            <GroupAllUsers />
            <Autocomplete
                id="related-field"
                name="related"
                multiple
                autoHighlight
                options={epList}
                getOptionLabel={(ep) => `EP${ep.epId}: ${ep.title}`}
                value={related ? related.split(",").map(epId => epList.find(ep => ep.epId.toString() === epId)) : []}
                onChange={(_, newValue) => handleChange("related", newValue.map(ep => ep.epId).join(","))}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        label={xplanLabels.related}
                        InputLabelProps={{ shrink: true }}
                    />
                }
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Chip
                            variant="outlined"
                            label={option.epId}
                            {...getTagProps({ index })}
                            onClick={(event) => {
                                event.stopPropagation();
                                window.open(`/xplans/${option.epId}`, "_blank");
                            }}
                            onDelete={() => handleChange("related", value.filter((item) => item.epId !== option.epId).map((ep) => ep.epId).join(","))}
                        />
                    ))
                }
            />
            {!newPlan && <HistoryLogElement xplans={xplans} label={"related"} />}
        </div>
    );
};

export default Related;